import "bootstrap";
import * as Marionette from "backbone.marionette";
import "aurelia-polyfills";
import {autoinject, Container} from "aurelia-dependency-injection";
import {Router} from "./router";
import {AppSettings} from "./app-settings";
import {MasterView} from "./shared/views/master-view";
import {ErrorMessage} from "./shared/views/error-message";
import {ApplicationInsights} from "./shared/helpers/application-insights";
import { Utilities } from "./shared/helpers/utilities";
import { UserManager } from "oidc-client";
import oidcConfig from "./oidc-settings";
import { AuthService } from "./authentication/auth-service";
import { VersionChecker } from "./shared/helpers/version-checker";
import { AjaxHelper } from "./shared/helpers/ajax-helper";

(Promise as any).config({warnings: false});
$.support.cors = true;

// suppress bluebird promise warnings
window.addEventListener("unhandledrejection", async (e) => {
    e.preventDefault();
});

@autoinject
export class Main extends Marionette.Application {

   private appRegion: Marionette.Region;
   private historyOptions: Backbone.HistoryOptions = { pushState: true };

    constructor(
        private authService: AuthService,
        private masterView: MasterView,
        private router: Router,
        private appEvents: Backbone.Events,
        private errorMessage: ErrorMessage,
        private appInsights: ApplicationInsights,
    ) {
        super();
        this.on("start", async () => {
             await this.startApplication();
        });
    }

    public regions(): any {
        const regions: any = {
            appRegion: "#application-region"
        };
        return regions;
    }

    private async startApplication() {
        try {
            AjaxHelper.configureGlobalRequestHeaders();
            await VersionChecker.checkForUpdates();
            await this.authService.prepare(true);
        } catch (err) {
            this.errorMessage.handleError(err);
        } finally {
            await this.ready();
        }
    }

    private async ready() {
        try {
            this.appRegion.show(this.masterView);
            this.masterView.trigger("show");
            this.authService.AppUser.trigger("refresh");
        } catch (err) {
            this.errorMessage.handleError(err);
        } finally {
           Backbone.history.start(this.historyOptions);
        }
    }

}

const container = new Container();
container.makeGlobal();
container.get(Main).start();



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/main.ts